import React from "react";

/**
 * EmptyChart — dashed placeholder shown inside a chart card when the
 * underlying dataset is empty (e.g. no calls in the selected range).
 */
const EmptyChart = ({ label, height = 120 }) => (
  <div
    className="flex items-center justify-center text-on-surface-light-variant/70 dark:text-on-surface-variant/70 text-xs rounded-lg bg-surface-light-low dark:bg-surface-container-low border border-dashed border-surface-light-highest dark:border-white/5"
    style={{ height }}
  >
    {label}
  </div>
);

export default EmptyChart;
